import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {gsap} from "gsap";
import {HTHWinConfig} from "../configs/HTHWinConfig";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHGameMode} from "../server/HTHGameMode";
import {HTHSound} from "../sound/HTHSound";

export class HTHExtraSpinCountupSummary implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return !HTH.model.brokeTheBank && !HTH.model.isBigWin  && !HTH.model.isNextAvalanche && !HTH.model.isGodModeMaxWin
            && HTH.model.isExtraSpinEndingAuto;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                if (HTH.model.isExtraSpinEndingAuto) {
                    HTH.gameViewContainer.scatterCollector.showScatterCollector(false);
                    HTH.backgroundElements.setMode(HTH.model.data.nextMode);
                    HTHSound.switchMusic({name: HTHSound.MAIN_GAME_MUSIC});
                }
                HTH.keypadPlugin.setWin(HTH.model.gameData.accumulatedRoundWin, true, HTHHelper.isWinBelowStake());
                controller.finish();
            }
        });
        const isWinBelowStake: boolean = HTHHelper.isWinBelowStake();
        controller.setSkipCallback();

        /*   if (!isWinBelowStake) {
               tl.add(HTH.totalWinView.showInExtraSpin(HTHWinConfig.getWinConfig(HTH.model.data.accumulatedRoundWin/HTH.model.gameData.playedBetValue)));

           }*/
        tl.to(this, {duration: 0.01});

        /*   if (HTH.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
               tl.timeScale(1.4);
           }*/
    }
}
